(() => {
  const SELECTOR = '[data-our-story]';

  const init = (root) => {
    if (!root || root.dataset.osReady === 'true') return;
    root.dataset.osReady = 'true';

    const nodes = root.querySelectorAll('[data-os-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach((el) => io.observe(el));
  };

  const boot = () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(SELECTOR) || event.target?.closest?.(SELECTOR);
    if (root) {
      root.dataset.osReady = 'false';
      init(root);
    } else {
      boot();
    }
  });
})();
